import { render, staticRenderFns } from "./FallbackCard.vue?vue&type=template&id=7c120820"
import script from "./FallbackCard.vue?vue&type=script&lang=ts"
export * from "./FallbackCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports